import { Component, Injector, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { Unsubscribable } from '@bcf-v2-platforms/platform-worker/browser';
import { AppLoadedService } from '@bcf-v2-ui-shared/services/app-loaded.service';
import type { AppMaintenanceService } from '@bcf-v2-ui-shared/services/app-maintenance.service';
import { maintenanceRoutePath } from '@bcf-v2/routes/common/app/paths/maintenance-route-path';

@Component({
  standalone: true,
  selector: 'bcf-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html'
})
export class AppComponent extends Unsubscribable implements OnInit {
  constructor(
    private _router: Router,
    private _injector: Injector,
    private _appLoadedService: AppLoadedService
  ) {
    super();
  }

  public ngOnInit(): void {
    this._initApp();
    this._appLoadedService.init();
    this._initAppMaintenance();
    this._initLogRocket();
    this._initAppDestroy();
  }

  private async _initApp(): Promise<void> {
    this._injector
      .get(
        (
          await import(
            /* webpackChunkName: "app-initializator" */ '@apps/projects/casino/lvbetcom/mobile-web/src/app/app-initializator'
          )
        ).LazyInitializatorCsLvbetcomMobileWeb
      )
      .init();
  }

  private async _initAppMaintenance(): Promise<void> {
    const instance: AppMaintenanceService = this._injector.get(
      (await import(/* webpackChunkName: "app-maintenance" */ '@bcf-v2-ui-shared/services/app-maintenance.service'))
        .AppMaintenanceService
    );
    this._sub = instance.doRedirectToMaintenance().subscribe(() => this._router.navigate([maintenanceRoutePath()]));
  }

  private async _initLogRocket(): Promise<void> {
    this._injector
      .get(
        (
          await import(
            /* webpackChunkName: "log-rocket" */ '@bcf-v2-ui-utilities/analytics/log-rocket-initializer.service'
          )
        ).LogRocketInitializerService
      )
      .init();
  }

  private async _initAppDestroy(): Promise<void> {
    this._injector
      .get(
        (await import(/* webpackChunkName: "app-destroy" */ '@bcf-v2-ui-shared/services/app-destroy.service'))
          .AppDestroyService
      )
      .init();
  }
}
